import * as types from 'actions/types';
import { createReducer, successType } from 'shared/lib/lib/callAPI';

const dataReducer = (state = null, action) => {
  switch (action.type) {
    case successType(types.GET_CURRENT_USER):
      if (action.response && action.response.length > 0) {
        const currentUser = action.response[0];
        // Rolle als Klartext (kein Sicherheitsmechanismus: liegt ohnehin im Klartext
        // in Redux/API; ein client-seitiger Key landet inline im JS-Bundle).
        localStorage.setItem('current-user-role', currentUser.role);
        return { ...action.response[0] };
      }
      return state;
    case successType(types.UPDATE_USER):
      if (action.response) {
        return { ...action.response };
      }
      return state;
    case types.LOGOUT:
      return null;
    default:
      return state;
  }
};

export default createReducer([types.GET_CURRENT_USER], dataReducer);
